'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Container = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color: ', ';\n  background-image: ', ';\n  color: ', ';\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  position: relative;\n'], ['\n  align-items: center;\n  background-color: ', ';\n  background-image: ', ';\n  color: ', ';\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  position: relative;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SmartImage = require('./SmartImage');

var _toolkit = require('../../utils/toolkit');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = exports.Container = _styledComponents2.default.div(_templateObject, function (_ref) {
    var backgroundColor = _ref.backgroundColor;
    return backgroundColor;
}, function (_ref2) {
    var gradient = _ref2.gradient,
        backgroundColor = _ref2.backgroundColor;

    return gradient ? getGradientFor(backgroundColor) : '';
}, function (_ref3) {
    var textColor = _ref3.textColor;
    return textColor;
});
function getGradientFor(bgColor) {
    var primaryColor = bgColor.toLowerCase();
    var _SmartImage$colorsSup = _SmartImage.SmartImage.colorsSupportedGradients,
        red = _SmartImage$colorsSup.red,
        lightBlue = _SmartImage$colorsSup.lightBlue,
        darkBlue = _SmartImage$colorsSup.darkBlue,
        green = _SmartImage$colorsSup.green;

    var gradientColor = void 0;
    switch (primaryColor) {
        case darkBlue:
            gradientColor = setGradientFor(primaryColor, '#226399');
            break;
        case lightBlue:
            gradientColor = setGradientFor(primaryColor, (0, _toolkit.color)('primary', 500));
            break;
        case red:
            gradientColor = setGradientFor(primaryColor, (0, _toolkit.color)('error', 300));
            break;
        case green:
            gradientColor = setGradientFor(primaryColor, (0, _toolkit.color)('success'));
            break;
        default:
            gradientColor = '';
    }
    return gradientColor;
}
function setGradientFor(primaryColor, gradientColor) {
    var gradientType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'radial-gradient';

    return gradientType + '(ellipse farthest-corner at center, ' + gradientColor + ' 0%, ' + primaryColor + ' 100%)';
}
//# sourceMappingURL=SmartImage.styled.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/SmartImage/SmartImage.styled.js